module.exports = {
  pages: [
    {
      // Dashboard
      pageId: 82,
      steps: [
        {
          target: '#tour-nav-dashboard',
          content: 'The dashboard is your summary page where you can view all your bookings in one place',
          header: { title: '1/9' },
          params: {
            placement: 'right',
          },
        },
        {
          target: '#tour-nav-upcomingtrips',
          content: 'View your bookings per trip, including your wine, car hire and transfers orders',
          header: { title: '2/9' },
          params: {
            placement: 'right',
          },
        },
        {
          target: '#tour-nav-experiences',
          content: 'Start planning your dream holiday with our range of tailored experiences',
          header: { title: '3/9' },
          params: {
            placement: 'right',
          },
        },
        {
          target: '#tour-nav-guestmanager',
          content: 'Tell us who is travelling with you, manage passports and invite others to help plan your trip',
          header: { title: '4/9' },
          params: {
            placement: 'right',
          },
        },
        {
          target: '#tour-nav-travel',
          content: 'Manage your group\'s flight or ferry information to help us coordinate your arrival and departure',
          header: { title: '5/9' },
          params: {
            placement: 'right',
          },
        },
        {
          target: '#tour-nav-billing',
          content: 'Review and complete payments and check your booking cancellation policies',
          header: { title: '6/9' },
          params: {
            placement: 'right',
          },
        },
        {
          target: '#tour-viewbooking',
          content: 'Learn more about your villa stay, discover what amenities are nearby and view any addons',
          header: { title: '7/9' },
          params: {
            placement: 'right',
          },
        },
        {
          target: '#tour-timeline',
          content: 'Your checklist timeline holds a helpful list of actions to complete before your departure',
          header: { title: '8/9' },
          params: {
            placement: 'left',
          },
        },
        {
          target: '#tour-button',
          content: 'If you get lost you can always open this tour from the guide home. Enjoy planning your trip!',
          header: { title: '9/9' },
          params: {
            placement: 'bottom',
          },
        },
      ],
    },
    {
      // Experiences
      pageId: 771,
      steps: [
        {
          target: '#tour-villa-dropdown',
          content: 'Select your villa booking and start planning your itinerary here',
          header: { title: '1/3' },
          params: {
            placement: 'right',
            enableScrolling: false,
            buttonNext: false,
          },
        },
        {
          target: '.tour-dayplanner-first',
          content: 'Click on a day to discover experiences available and submit a request',
          header: { title: '2/3' },
          params: {
            placement: 'right',
            enableScrolling: false,
          },
        },
        {
          target: '#tour-experiences-basket',
          content: 'Once your experience requests are confirmed as available, you can proceed to confirm and pay for them here',
          header: { title: '3/3' },
          params: {
            placement: 'bottom',
            enableScrolling: false,
          },
        },
      ],
    },
  ],
};
